import { render } from "./ViewHome.vue?vue&type=template&id=5b34fad0&scoped=true&ts=true"
import script from "./ViewHome.vue?vue&type=script&lang=ts"
export * from "./ViewHome.vue?vue&type=script&lang=ts"

import "./ViewHome.vue?vue&type=style&index=0&id=5b34fad0&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b34fad0"]])

export default __exports__